<div class="filters">
  <div class="filter">
    <label for="auftragsnummer">Auftragsnummer</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterOrders()"
        [(ngModel)]="auftragsnummer"
        id="auftragsnummer"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label for="auftraggeber">Kunde</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterOrders()"
        [(ngModel)]="auftraggeber"
        id="auftraggeber"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label for="standort">Standort</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterOrders()"
        [(ngModel)]="standort"
        id="standort"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>
  <div class="filter inspector-filter">
    <label for="inspector">Prüfende Person</label>
    <p-dropdown
      (ngModelChange)="onInspectorChange()"
      [(ngModel)]="selectedInspector"
      [options]="inspectorFilterItems"
      [showClear]="showClearButton"
      inputId="inspector"
      placeholder="Alle"
    />
  </div>

  <div class="filter date-filter">
    <label for="startDate">Startdatum</label>
    <div class="input-wrapper">
      <p-calendar
        [(ngModel)]="rangeDatesStart"
        [iconDisplay]="'input'"
        [ngClass]="{'invalid-input': !isStartDateRangeValid()}"
        [showButtonBar]="true"
        [showIcon]="true"
        dateFormat="dd.mm.yy"
        inputId="startDate"
        placeholder="Datum"
        selectionMode="range"
      ></p-calendar>
      <div *ngIf="!isStartDateRangeValid()" class="error">Bitte wählen Sie Start- und Enddatum aus.</div>
    </div>
  </div>


  <div class="filter date-filter">
    <label for="endDate">Enddatum</label>
    <div class="input-wrapper">
      <p-calendar
        [(ngModel)]="rangeDatesEnd"
        [iconDisplay]="'input'"
        [ngClass]="{'invalid-input': !isEndDateRangeValid()}"
        [showButtonBar]="true"
        [showIcon]="true"
        dateFormat="dd.mm.yy"
        inputId="endDate"
        placeholder="Datum"
        selectionMode="range"
      />
      <div *ngIf="!isEndDateRangeValid()" class="error">Bitte wählen Sie Start- und Enddatum aus.</div>
    </div>
  </div>
  <div class="filter">
    <label for="status">Status</label>
    <p-multiSelect
      (keydown.enter)="filterOrders()"
      [(ngModel)]="selectedStatus"
      [group]="true"
      [options]="statusFilterItems"
      display="chip"
      inputId="status"
      placeholder="Alle"
      scrollHeight="250px"
    >
      <ng-template let-group pTemplate="group">
        <div class="flex align-items-center">
          <span>{{ group.label }}</span>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <app-button (click)="filterOrders()" label="Filtern" type="primary-button" />

  <app-button
    (click)="clearFilter()"
    label="Filter zurücksetzen"
    type="secondary-button"
  />
</div>
